module.exports = __webpack_public_path__ + "media/yi2.c6b7cfe4.mp4";